import { PEOPLE_DIRECTORY, WIKI } from '@confluence/named-routes/entry-points/routes.ts';

const PEOPLE_DIRECTORY_PATH = PEOPLE_DIRECTORY.toUrl().replace(/\/$/, '');
const WIKI_CONTEXT_PATH = WIKI.toUrl().replace(/\/$/, '');
type OptionalString = string | null | undefined;

export const buildTaskAssigneeProfileUrl = (accountId: string): string =>
	`${PEOPLE_DIRECTORY_PATH}/${accountId}?ref=confluence`;

export const buildTaskContainerUrl = (
	base: OptionalString,
	webUi: OptionalString,
): string | null => {
	if (!base || !webUi) {
		return null;
	}

	return `${base}${webUi}`;
};

export function normalizeTaskUrl(url: string | null | undefined): string | null {
	if (!url) {
		return null;
	}

	if (
		/^https?:\/\//i.test(url) ||
		url === WIKI_CONTEXT_PATH ||
		url.startsWith(`${WIKI_CONTEXT_PATH}/`)
	) {
		return url;
	}

	if (url.startsWith('/')) {
		return `${WIKI_CONTEXT_PATH}${url}`;
	}

	return `${WIKI_CONTEXT_PATH}/${url}`;
}
